/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ used: NonNullable<unknown>, limit: NonNullable<unknown> }} Backend_Session_Error_QuotaInputs */

const en_backend_session_error_quota = /** @type {(inputs: Backend_Session_Error_QuotaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quota exceeded: ${i?.used} used out of ${i?.limit}. Quota resets on a 24h sliding window.`)
};

const fr_backend_session_error_quota = /** @type {(inputs: Backend_Session_Error_QuotaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quota dépassé : ${i?.used} utilisés sur ${i?.limit}. Le quota se réinitialise sur une fenêtre glissante de 24 h.`)
};

const ms_sg2_backend_session_error_quota = /** @type {(inputs: Backend_Session_Error_QuotaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kuota melebihi: ${i?.used} digunakan daripada ${i?.limit}. Kuota ditetapkan semula pada tingkap gelongsor 24 jam.`)
};

/**
* | output |
* | --- |
* | "Quota exceeded: {used} used out of {limit}. Quota resets on a 24h sliding window." |
*
* @param {Backend_Session_Error_QuotaInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const backend_session_error_quota = /** @type {((inputs: Backend_Session_Error_QuotaInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Backend_Session_Error_QuotaInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_backend_session_error_quota(inputs)
	if (locale === "fr") return fr_backend_session_error_quota(inputs)
	return ms_sg2_backend_session_error_quota(inputs)
});